import React from 'react';
import { View, Text, Link } from '@react-pdf/renderer';
import { cvStyles } from '../cvStyles';

/**
 * Componente Header del CV
 * Muestra información personal y de contacto
 */
export const CVHeader = ({ personal }) => {
  // Filtrar Email y Phone de socialLinks ya que se muestran por separado
  const filteredSocialLinks = personal.socialLinks?.filter(
    link => link.name !== 'Email' && link.name !== 'Phone'
  ) || [];

  return (
    <View style={cvStyles.header}>
      <Text style={cvStyles.name}>{personal.name}</Text>
      <Text style={cvStyles.title}>{personal.title}</Text>
      
      <View style={{ marginTop: 12, flexDirection: 'row', flexWrap: 'wrap', gap: 15 }}>
        {/* Teléfono */}
        {personal.phone && (
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Text style={{ fontSize: 9, color: '#475569', fontFamily: 'Helvetica-Bold', marginRight: 4 }}>
              Tel:
            </Text>
            <Text style={{ fontSize: 9, color: '#64748b' }}>
              {personal.phone}
            </Text>
          </View>
        )}

        {/* Email */}
        {personal.email && (
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Text style={{ fontSize: 9, color: '#475569', fontFamily: 'Helvetica-Bold', marginRight: 4 }}>
              Email:
            </Text>
            <Link src={`mailto:${personal.email}`} style={{ fontSize: 9, color: '#1e3a8a', textDecoration: 'none' }}>
              {personal.email}
            </Link>
          </View>
        )}

        {/* Social Links con show_in_cv=true (excepto Email y Phone) */}
        {filteredSocialLinks.map((link, index) => (
          <View key={index} style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Text style={{ fontSize: 9, color: '#475569', fontFamily: 'Helvetica-Bold', marginRight: 4 }}>
              {link.name}:
            </Text>
            <Link src={link.url} style={{ fontSize: 9, color: '#1e3a8a', textDecoration: 'none' }}>
              {link.url.replace('https://', '').replace('http://', '')}
            </Link>
          </View>
        ))}
      </View>
    </View>
  );
};
